module.exports = "images/doc-big.png";